import { Howl } from "howler";
import { GameServices } from "game/GameServices";
import { devLog, devLogWarn } from "utils/Misc";

type SoundList = { [key: string]: { "name": string, "volume": number } };

type SoundOptions = {
    loop?: boolean,
    vol?: number,
    onComplete?: Function
}

export class SoundSystem {
    private readonly list: SoundList;
    private readonly sounds: Record<string, Howl> = {};

    enableLogging: boolean = false;

    constructor(protected readonly services: GameServices) {
        this.list = this.services.resources.getSetting(`sound-settings`).data;
    }

    play(name: string, options: SoundOptions = {}): Howl | undefined {

        const { sound, volume } = this.getSoundData(name);

        if (sound) {
            if (this.enableLogging) devLog(`Sound played: ` + name);

            const { loop, vol, onComplete } = options;

            sound.stop();
            sound.volume((vol) ? vol : volume);
            sound.loop(loop ?? false);
            sound.play();

            if (onComplete) {
                sound?.once(`end`, () => onComplete());
            }

            return sound;
        }
        else {
            if (this.enableLogging) devLogWarn(`Sound NOT played: ` + name);
        }
    }

    stop(name: string): void {

        const { sound } = this.getSoundData(name);
        sound?.stop();
    }

    getSoundData(key: string): { sound?: Howl, volume: number } {

        const data = this.list[key];
        let sound;
        if (data) {
            sound = this.getSound(data.name);
            return { sound, volume: data.volume };
        }
        else {
            devLogWarn(`Sound not found with key: ` + key);
            return { sound, volume: 0 };
        }
    }

    reset(): void {

        for (const sound of Object.values(this.sounds)) {
            sound.stop();
        }
    }

    private getSound(sound: string): Howl | undefined {

        if (this.services.audio.soundReady === true) {

            const existingSound = this.sounds[sound];

            if (existingSound) {
                return existingSound;
            } else {

                const audio = this.services.resources.getAudio(sound + `.m4a`);
                if (audio) {
                    var howl = new Howl({
                        src: audio
                    });

                    this.sounds[sound] = howl;

                    return howl;
                }
                else {
                    if (this.enableLogging) devLogWarn(`Sound not found: ` + sound + `.m4a`);
                }
            }
        }
    }
}